import config from "config";
import { RSAA } from "redux-api-middleware";
export const getDrugs = (
  pageSize,
  page,
  sorted,
  filtered,
  resized,
  expanded
) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/cat/drugs/list`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pageSize, page, sorted, filtered }),
      types: [
        {
          type: "FETCH_ALL_DRUG_LIST",
          payload: {
            listState: { pageSize, page, sorted, filtered, resized, expanded },
          },
        },
        "FETCH_ALL_DRUG_LIST_SUCCESS",
        "FETCH_ALL_DRUG_LIST_FAILURE",
      ],
    },
  };
};

export const updateIndexOnList = (index) => {
  return {
    type: "FETCH_ALL_DRUG_LIST_INDEX",
    payload: { index: index },
  };
};

export const resetError = () => {
  return {
    type: "RESET_ERROR_ALL_DRUG_LIST",
  };
};

export const resetAllDrugList = () => {
  return {
    type: "RESET_ALL_DRUG_LIST",
  };
};
